export interface SubMenuType {
    title: string;
    link: string;
    openFlag: boolean;
    external?: boolean; // 외부 절대 URL이면 true → 새 탭으로 오픈
    navKey?: string; // renewal GNB 사전(data/i18n-dist/Nav)의 키 — 있으면 헤더 메뉴와 같은 문구를 쓴다
}

export interface HomeMenuType {
    title: string;
    subTitle: SubMenuType[];
    openFlag: boolean;
    link?: string; // 값이 있으면 드롭다운 없이 직접 링크되는 최상위 메뉴
    external?: boolean; // 외부 절대 URL이면 true → 새 탭으로 오픈
    navKey?: string; // renewal GNB 사전(data/i18n-dist/Nav)의 키 — 있으면 헤더 메뉴와 같은 문구를 쓴다
}

export const homeMainHeaderMenu: HomeMenuType[] = [
    {
        title: "platform",
        subTitle: [
            {
                title: "skillCertify",
                link: "/home/skillCertify",
                openFlag: false
            },
            {
                title: "skillMonitor",
                link: "/home/skillMonitor",
                openFlag: false
            },
            {
                title: "skillAdvance",
                link: "/home/skillAdvance",
                openFlag: false
            }
        ],
        openFlag: false
    },
    {
        title: "solutions",
        subTitle: [
            {
                title: "hiring",
                link: "/home/hiring",
                openFlag: false
            }
        ],
        openFlag: false
    },
    {
        title: "resources",
        subTitle: [
            {
                title: "news",
                link: "/home/news",
                openFlag: false
            },
            {
                title: "events",
                link: "/home/events",
                openFlag: false
            }
        ],
        openFlag: false
    },
    {
        title: "axlog",
        link: "https://blog.codepresso.io",
        external: false,
        subTitle: [],
        openFlag: false
    },
    {
        title: "pricing",
        link: "/home/pricing",
        subTitle: [],
        openFlag: false
    },
]

// 푸터 사이트맵. 헤더 GNB(renewal SiteNav)와 같은 항목은 navKey 로 renewal 사전의 문구를 그대로 쓴다 —
// 언어별 표기가 헤더와 어긋나지 않게. 링크는 renewal 마크업의 codepresso.io 주소를 우리 경로로 옮긴 것.
export const homeMainFooterMenu: HomeMenuType[] = [
    {
        title: "skills",
        navKey: "nav-skills-trigger",
        subTitle: [
            { title: "aifluent", navKey: "nav-skills-aifluent-name", link: "/aifluent", openFlag: false },
            { title: "skillcertify", navKey: "nav-skills-skillcertify-name", link: "/skillcertify", openFlag: false },
            { title: "skillfit", navKey: "nav-skills-skillfit-name", link: "/skillfit", openFlag: false },
            { title: "skillpath", navKey: "nav-skills-skillpath-name", link: "/skillpath", openFlag: false },
            { title: "skillcamp", navKey: "nav-skills-skillcamp-name", link: "/skillcamp", openFlag: false }
        ],
        openFlag: false
    },
    {
        title: "automation",
        navKey: "nav-automation-trigger",
        subTitle: [
            { title: "axbuild", navKey: "nav-automation-axbuild-name", link: "/ax-build", openFlag: false },
            { title: "axgrow", navKey: "nav-automation-axgrow-name", link: "/ax-grow", openFlag: false }
        ],
        openFlag: false
    },
    {
        title: "why",
        navKey: "nav-why-trigger",
        subTitle: [
            { title: "structure", navKey: "nav-why-structure-name", link: "/why-codepresso", openFlag: false },
            { title: "cases", navKey: "nav-why-cases-name", link: "/cases", openFlag: false },
            { title: "company", navKey: "nav-why-company-name", link: "/company", openFlag: false }
        ],
        openFlag: false
    },
    {
        title: "insight",
        navKey: "nav-insight-title",
        subTitle: [
            { title: "axlog", navKey: "nav-insight-axlog-name", link: "https://blog.codepresso.io/", openFlag: false },
            { title: "naverblog", navKey: "nav-insight-naverblog-name", link: "https://blog.naver.com/code-presso", external: true, openFlag: false },
            { title: "newsroom", navKey: "nav-insight-newsroom-name", link: "/home/news", openFlag: false },
            { title: "events", navKey: "nav-insight-events-name", link: "/home/events", openFlag: false }
        ],
        openFlag: false
    },
    {
        title: "pricing",
        navKey: "nav-pricing",
        link: "/home/pricing",
        external: false,
        subTitle: [],
        openFlag: false
    },
    {
        title: "get_started",
        subTitle: [
            {
                title: "request_demo",
                link: "/home/request/demo",
                openFlag: false
            },
            {
                title: "contact",
                link: "/home/contact",
                openFlag: false
            }
        ],
        openFlag: false
    }
];